import { Store } from "@ngxs/store";
import { UserState } from "src/app/platform-web3/user.state";
import { GadgetDeployMetadata } from "../../data";

/** 代表 web2 的 gadget proxy 功能。 */
export class GadgetProxy {
    #gadgetid = '';

    constructor(
        private gadget: GadgetDeployMetadata,
        private accessPoint: string,
    ) {
        this.#gadgetid = GadgetProxy.generateId(gadget);

        try {
            if(typeof(gadget.params) === 'object') {
                this.params = gadget.params;
            } else {
                this.params = JSON.parse(gadget.params);
            }

        } catch (err) {
            console.log(err);
        }

    }

    /** 產生一個 gadget id。 */
    public static generateId(gadget: GadgetDeployMetadata) {
        return `${gadget.dsns}:${gadget.targetType}:${gadget.module.guid}`;
    }

    /** gadget id 唯一識別，包含「dsns、role、guid」。 */
    get id() {
        return this.#gadgetid;
    }

    get guid() {
        return this.gadget.getGuid();
    }

    /** 在 web3(1campus) 的 url。
    *   deployment/1AF892ED-B4BB-41B1-9300-5D7E7B644351/content.htm
    *   ?id=demo.1campus.h_%E6%95%99%E5%B8%AB_1AF892ED-B4BB-41B1-9300-5D7E7B644351
    */
    get web3_url() {
        return `/web2/deployment/${this.guid}/content.htm?id=${this.id}`;
    }

    /** 以下為 web2 gadget proxy API。 */

    activeGadget() {
        console.warn('activeGadget notsupported!')
    }

    connect(accesspoint: string, account: string, password: string) {
      const web2auth = window['auth'];
      return web2auth.connectTo(accesspoint, account, password);
    }

    getContract(contract: string) {
        const web2auth = window['auth'];
        return web2auth.connectTo(`${this.gadget.dsns}/${contract}`);
    }

    getApplication() {
        return {
            accessPoint: this.accessPoint,
        }
        console.warn('getApplication not full supported!')
    }

    getUserInfo() { console.warn('getUserInfo notsupported!!!') }

    params: any;

    getSize() { console.warn('getSize notsupported!') }

    setExterior(config: any) {
        console.warn('setExterior notsupported!')
    }

    onSizeChanged(callBack: any) { console.warn('onSizeChanged notsupported!') }

    onLeave() { console.warn('onLeave notsupported!') }

    getPreference(callBack: any) { console.warn('getPreference notsupported!') }

    setPreference(obj: any) { console.warn('setPreference notsupported!') }

    autofit() { console.warn('autofit notsupported!') }

    onBookmarkChanged(callBack: any) { console.warn('onBookmarkChanged notsupported!') }

    setBookmark(bookmark: any) { console.warn('setBookmark notsupported!') }

    getGroupGadgets() { console.warn('getGroupGadgets notsupported!') }

    // 暫不支援，需要再說。
    getLanguage() { console.warn('getLanguage notsupported!') }

    onLanguageChanged(callBack: any) { console.warn('onLanguageChanged notsupported!') }

    backToMenu() { console.warn('backToMenu notsupported!') }
}
